"use client";
import React from 'react'
import Image from "next/image";
import { useTheme } from "next-themes";
const heroImage = () => {
    const { theme } = useTheme();
  return (
    <>
      <Image
            width={1200}
            height={1200}
            suppressHydrationWarning
            className="w-full md:w-[1200px] mx-auto rounded-lg relative rouded-lg leading-none flex items-center border border-t-2 border-secondary  border-t-primary/30"
            src={
              theme === "light"
                ? "/hero-image-light.jpeg"
                : "/hero-image-dark.jpeg"
            }
            alt="dashboard"
          />
    </>
  )
}

export default heroImage
